<template>
    <div class="llp-switch form-check form-check-inline form-switch form-control-sm">
        <input :id="id" :checked="model" :class="classNames" :disabled="disabled" :name="id"
               class="form-check-input" type="checkbox" @click="$emit('update:model', $event.target.checked)">
        <label :aria-label="label" :for="id" class="form-check-label fs-6">
            {{ label }}
        </label>
    </div>
</template>
<script>
export default {
  name: 'BaseSwitch',
  props: {
    model: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    classNames: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['update:model'],
};
</script>